import React, { PropTypes, Component } from 'react'
import TextInput from 'components/Form/components/TextInput'
import styles from '../../BeneficiaryDisplayForm.scss'

class TrustForm extends Component {
    static propTypes = {
      form: PropTypes.object.isRequired,
      handleChange: PropTypes.func.isRequired,
      handleFocus: PropTypes.func.isRequired,
      handleValidation: PropTypes.func.isRequired,
      schema: PropTypes.object.isRequired,
    }

    render() {
      const {
        schema, form, handleChange, handleValidation, handleFocus,
      } = this.props

      return (
        <div className={styles.fieldset}>
          <li>
            <TextInput
              {...schema.trustName}
              error={form.trustName.error}
              handleChange={handleChange}
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.trustName.value}
              valid={form.trustName.valid}
            />
          </li>
          <li>
            <TextInput
              {...schema.trusteeName}
              error={form.trusteeName.error}
              handleChange={handleChange}
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.trusteeName.value}
              valid={form.trusteeName.valid}
            />
          </li>
        </div>
      )
    }
}

export default TrustForm



// WEBPACK FOOTER //
// ./src/views/Beneficiaries/components/Beneficiary/TrustForm.js